module.exports = __webpack_public_path__ + "static/media/class_3.8b169f18.svg";